import { useAuthStore } from '@/features/auth/store/auth-store';
import { TOKEN_KEY } from '@/lib/utils/constants';
import { clavePorPortal, slugDeLaClave } from '@/lib/utils/portal-storage';
import { storage } from '@/lib/utils/storage';
import { esEmpresaDemo, recienConvertida } from '../empresa-demo';
import { modoDeEscena } from './modo-de-animacion';

/*
  Los momentos que se ven una sola vez por empresa. La marca va en el navegador porque
  no cuentan como uso y no deben escribir nada en el servidor. Se pone con la escena
  lista: si el 3D llegó tarde, el comercio no pierde el momento.
*/
export type MomentoUnico = 'ingreso' | 'plan-prueba';

const clave = (momento: MomentoUnico) =>
  clavePorPortal(`mini_momento_${momento}`, slugDeLaClave(TOKEN_KEY));

function sePuedeRecordar(): boolean {
  try {
    window.localStorage.setItem('mini_momento_prueba', '1');
    window.localStorage.removeItem('mini_momento_prueba');
    return true;
  } catch {
    return false;
  }
}

export function marcarMomento(momento: MomentoUnico): void {
  storage.set(clave(momento), true);
}

/** La única puerta de estos momentos. WebGL se prueba al final: lo demás no cuesta nada. */
export function puedeVerseMomento(momento: MomentoUnico): boolean {
  if (!esEmpresaDemo() || useAuthStore.getState().isImpersonating) return false;
  if (storage.get<boolean>(clave(momento)) === true || !sePuedeRecordar()) return false;
  return modoDeEscena() === 'animada';
}

const MOMENTOS_UNICOS: readonly MomentoUnico[] = ['ingreso', 'plan-prueba'];

/**
 * ¿Falta algún momento por mostrar? Sólo mira lo anotado (no prueba WebGL): sirve para no
 * bajar el módulo del 3D cuando los dos únicos ya se vieron y no hay conversión pendiente.
 */
export function quedaMomentoPorVer(): boolean {
  return recienConvertida() || MOMENTOS_UNICOS.some((m) => storage.get<boolean>(clave(m)) !== true);
}
